export const ePaymentTerms: { [key: string]: string } = {
    CASH: 'Cash',
    NET_30: 'Net 30',
    NET_60: 'Net 60',
    NET_90: 'Net 90'
};
